<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap class="mt-4" justify-space-around>

      <v-flex xs12 sm12 md4 lg3>
        <v-card>
          <v-card-title>
            {{ $t('yourBalance') }}
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="grey--text">
            <h1> {{ $store.state.userBalance | currency }} </h1>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md4 lg3>
        <v-card>
          <v-card-title>
            {{ $t('monthlySuccessShipments') }}
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="grey--text">
            <h1> {{ totalCurrentMonth }} </h1>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md4 lg3>
        <v-card>
          <v-card-title>
            {{ $t('totalSuccessShipments') }}
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="grey--text">
            <h1> {{ total }} </h1>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="notices.length">
        <v-card>
          <v-card-text class="grey--text">
            <v-alert v-for="notice of notices" :key="notice.id" :value="true" :color="notice.notice_type" :icon="noticeIcon(notice)" outline>
              <span v-html="notice.description"></span>
            </v-alert>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="$auth.isDev()">
        <v-card>
          <v-card-title>
            {{ $t('currentMonthByCarrier') }}
          </v-card-title>

          <v-card-text class="grey--text">
            <v-data-table class=""
                          hide-headers
                          :items="currentMonthByCarrier"
                          hide-actions
                          :no-data-text="$t('noDataAvailable')">
              <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
              <template v-slot:items="props">
                <td> {{ props.item.name }} </td>
                <td> {{ props.item.count }} </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="$auth.isDev()">
        <v-card>
          <v-card-title>
            {{ $t('lastMonthByCarrier') }}
          </v-card-title>

          <v-card-text class="grey--text">
            <v-data-table class=""
                          hide-headers
                          :items="lastMonthByCarrier"
                          hide-actions
                          :no-data-text="$t('noDataAvailable')">
              <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
              <template v-slot:items="props">
                <td> {{ props.item.name }} </td>
                <td> {{ props.item.count }} </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="carriers"
                      :loading="loading"
                      :no-data-text="$t('noDataAvailable')"
                      v-if="!$auth.isCust() && carriers.length > 0">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td> {{ props.item.name }} </td>
            <td> {{ props.item.shipment_limit }} </td>
            <td> {{ props.item.shipment_count }} </td>
            <td> {{ props.item.shipments_left }} </td>
          </template>
        </v-data-table>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import Dashboard from '@/client/dashboard'

export default {
  name: 'DashboardView',

  props: {},

  data () {
    return {
      headers: [
        { text: this.$t('attrs.name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('attrs.shipment_limit'), align: 'left', sortable: false, value: 'limit' },
        { text: this.$t('attrs.total_shipments'), align: 'left', sortable: false, value: 'shipment_count' },
        { text: this.$t('shipmentsLeft'), align: 'left', sortable: false, value: 'shipment_count' }
      ],
      carriers: [],
      dashboard: {},
      loading: false,
    }
  },

  components: {
  },

  computed: {
    total () {
      return this.dashboard.total || 0
    },

    totalCurrentMonth () {
      return this.dashboard.total_current_month || 0
    },

    activeUsers () {
      return this.dashboard.active_users || 0
    },

    notices () {
      return this.dashboard.notices || []
    },

    currentMonthByCarrier () {
      const obj = this.dashboard.current_month_by_carrier || {}
      return Object.keys(obj).map(key => {
        return {
          name: key,
          count: obj[key]
        }
      })
    },

    lastMonthByCarrier () {
      const obj = this.dashboard.last_month_by_carrier || {}
      return Object.keys(obj).map(key => {
        return {
          name: key,
          count: obj[key]
        }
      })
    },

    items () {
      let byCarrier = []
      if (this.dashboard.by_carrier) {

        Object.keys(this.dashboard.by_carrier).map(key => {
          byCarrier.push({
            name: key,
            count: this.dashboard.by_carrier[key]
          })
        })

      }
      return byCarrier
    }
  },

  methods: {
    noticeIcon (notice) {
      switch (notice.notice_type) {
        case 'info':
          return 'info'
        case 'warning':
          return 'priority_high'
        case 'error':
          return 'error'
        default:
          return ''
      }
    }
  },

  watch: {
  },

  async mounted () {
    this.loading = true
    this.dashboard = await Dashboard.all()
    this.carriers = this.dashboard.carriers
    this.loading = false
  }
}
</script>
